exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!../../static/css/SPHERETable.css"), "");

// module
exports.push([module.id, "\ntd.cellTextWrap {\r\n  max-width: 300px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\n}\n.wrapToolTip {\r\n  overflow-wrap: anywhere;\n}\r\n", ""]);

// exports
